import { create } from "zustand";
import { AreaAtuacao, SelectDados, DadoComplementarDefault, Diretoria } from "types/DadoComplementar";

interface DadoComplementarState {
  
  loadindDadosCompl: boolean;
  dadosComplementaresCarregados: boolean;
  lotacoes: SelectDados[];
  unidades: SelectDados[];
  diretorias: Diretoria[];
  diretoria_regionais: Diretoria[];
  diretoria_internas: Diretoria[];
  superintendencias: SelectDados[];
  instituicoesEstaduais: SelectDados[];
  areasAtuacao: AreaAtuacao[];
  orgaosAtuacao: DadoComplementarDefault[];
  vinculos: DadoComplementarDefault[];
  funcoes: DadoComplementarDefault[];
  funcoesDesempenhadas: DadoComplementarDefault[];

  setLoadingDadosCompl: (loading: boolean) => void;
  setDadosComplementaresCarregados: (loaded: boolean) => void;
  setLotacoes: (list: SelectDados[]) => void;
  setUnidades: (list: SelectDados[]) => void;
  setDiretorias: (list: Diretoria[]) => void;
  setDiretoriasRegionais: (list: Diretoria[]) => void;
  setDiretoriasInternas: (list: Diretoria[]) => void;
  setSuperintendencias: (list: SelectDados[]) => void;
  setInstituicoesEstaduais: (list: SelectDados[]) => void;
  setAreasAtuacao: (list: AreaAtuacao[]) => void;
  setOrgaosAtuacao: (list: DadoComplementarDefault[]) => void;
  setVinculos: (list: DadoComplementarDefault[]) => void;
  setFuncoes: (list: DadoComplementarDefault[]) => void;
  setFuncoesDesempenhadas: (list: DadoComplementarDefault[]) => void;

  /* funções reset */
  clearAll: () => void;
}

export const useDadoComplementarStore = create<DadoComplementarState>((set) => ({

  loadindDadosCompl: false,
  dadosComplementaresCarregados: false,
  lotacoes: [],
  unidades: [],
  diretorias: [],
  diretoria_regionais: [],
  diretoria_internas: [],
  superintendencias: [],
  instituicoesEstaduais: [],
  areasAtuacao: [],
  orgaosAtuacao: [],
  vinculos: [],
  funcoes: [],
  funcoesDesempenhadas: [],

  setLoadingDadosCompl: (loadindDadosCompl) => set({ loadindDadosCompl }),
  setDadosComplementaresCarregados: (dadosComplementaresCarregados) => set({ dadosComplementaresCarregados }),
  setLotacoes: (list) => set({ lotacoes: list }),
  setUnidades: (list) => set({ unidades: list }),
  setDiretorias: (list) => set({ diretorias: list }),
  setDiretoriasRegionais: (list) => set({ diretoria_regionais: list }),
  setDiretoriasInternas: (list) => set({ diretoria_internas: list }),
  setSuperintendencias: (list) => set({ superintendencias: list }),
  setInstituicoesEstaduais: (list) => set({ instituicoesEstaduais: list }),
  setAreasAtuacao: (list) => set({ areasAtuacao: list }),
  setOrgaosAtuacao: (list) => set({ orgaosAtuacao: list }),
  setVinculos: (list) => set({ vinculos: list }),
  setFuncoes: (list) => set({ funcoes: list }),
  setFuncoesDesempenhadas: (list) => set({ funcoesDesempenhadas: list }),

  clearAll: () =>
    set({
      loadindDadosCompl: false,
      dadosComplementaresCarregados: false,
      lotacoes: [],
      unidades: [],
      diretorias: [],
      diretoria_regionais: [],
      diretoria_internas: [],
      superintendencias: [],
      instituicoesEstaduais: [],
      areasAtuacao: [],
      orgaosAtuacao: [],
      vinculos: [],
      funcoes: [],
      funcoesDesempenhadas: [],
    }
  ),


}));
